
import React from 'react';
import { Navigate } from 'react-router-dom';

import { usePinAuth } from '@/hooks/usePinAuth';

interface AuthGuardProps {
  children: React.ReactNode;
}

const AuthGuard: React.FC<AuthGuardProps> = ({ children }) => {
  const { pinUser, loading: pinLoading, isAuthenticated: isPinAuthenticated } = usePinAuth();
  const bypass = typeof window !== 'undefined' && window.localStorage.getItem('e2e-auth') === 'true';

  if (!bypass && pinLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-lg">Chargement...</div>
      </div>
    );
  }

  if (!bypass && !isPinAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};

export default AuthGuard;
